import { Component } from "@theme/component";
import { ResizeNotifier } from "@theme/critical";

class ScrollingLayers extends Component {
  #notifier;

  connectedCallback() {
    super.connectedCallback();
    this.#notifier = new ResizeNotifier(this.#measure);
    for (const item of this.#items) this.#notifier.observe(item);
    this.#measure();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#notifier?.disconnect();
  }

  get #items() {
    return this.querySelectorAll(".scrolling-layer-item");
  }

  #measure = () => {
    requestAnimationFrame(() => {
      for (const item of this.#items) {
        item.style.setProperty("--item-height", `${item.offsetHeight}px`);
      }
    });
  };
}

if (!customElements.get("scrolling-layers")) {
  customElements.define("scrolling-layers", ScrollingLayers);
}
